import React from "react";

export default function Outdent(props) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 512.008 512.008"
      enableBackground="new 0 0 512.008 512.008"
      style={{ width: "20rem", height: "20rem" }}
    >
      <path
        fill={props.color}
        d="M501.342,106.671H10.675c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h490.667 c5.891,0,10.667,4.776,10.667,10.667S507.233,106.671,501.342,106.671z"
      />
      <path
        fill={props.color}
        d="M352.008,170.671H138.675c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
        h213.333c5.891,0,10.667,4.776,10.667,10.667C362.675,165.895,357.899,170.671,352.008,170.671z"
      />
      <path
        fill={props.color}
        d="M501.342,234.671H138.675c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
        h362.667c5.891,0,10.667,4.776,10.667,10.667C512.008,229.895,507.233,234.671,501.342,234.671z"
      />
      <path
        fill={props.color}
        d="M352.008,298.671H138.675c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
        h213.333c5.891,0,10.667,4.776,10.667,10.667C362.675,293.895,357.899,298.671,352.008,298.671z"
      />
      <path
        fill={props.color}
        d="M501.342,362.671H138.675c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
        h362.667c5.891,0,10.667,4.776,10.667,10.667C512.008,357.895,507.233,362.671,501.342,362.671z"
      />
      <path
        fill={props.color}
        d="M352.008,426.671H10.675c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h341.333
        c5.891,0,10.667,4.776,10.667,10.667S357.899,426.671,352.008,426.671z"
      />
      <path
        fill={props.color}
        d="M100.083,150.148c-3.985-1.654-8.574-0.745-11.627,2.304L3.123,237.786
        c-4.164,4.165-4.164,10.917,0,15.083l85.333,85.333c2.001,2.007,4.718,3.135,7.552,3.136c1.399,0.003,2.784-0.273,4.075-0.811
        c3.989-1.649,6.591-5.539,6.592-9.856V160.004C106.674,155.688,104.072,151.797,100.083,150.148z"
      />
    </svg>
  );
}
